import { useState, useEffect, useContext, memo } from "react";
import AuthContext from "../../store/auth-context";
import { useTranslation } from "react-i18next";

const Language = () => {
  const authCtx = useContext(AuthContext);
  const { i18n } = useTranslation();
  const [language, setLanguage] = useState("en");

  useEffect(() => {
    checkSelectedBrand();
  }, []);

  const checkSelectedBrand = () => {
    let htmlTag = document.getElementsByTagName("html");
    const params = new URLSearchParams(window.location.search);
    const brandNameFromUrl: any = params.get("brandName");
    let storedBrandName = localStorage.getItem("brandName");
    if (brandNameFromUrl && brandNameFromUrl !== null) {
      if (brandNameFromUrl === "burjeel") {
        const lang = localStorage.getItem("lang") ?? "en";
        setLanguage(lang);
        toggleLang(lang);
      } else {
        localStorage.removeItem("lang");
        i18n.changeLanguage("en");
        authCtx.setSelectedLanguage("en");
        setLanguage("en");
        htmlTag[0].removeAttribute("dir");
        document.body.classList.remove("rtl");
        removeRTLCSS();
      }
    } else {
      if (storedBrandName === "burjeel") {
        const lang = localStorage.getItem("lang") ?? "en";
        setLanguage(lang);
        toggleLang(lang);
      } else {
        localStorage.removeItem("lang");
        i18n.changeLanguage("en");
        authCtx.setSelectedLanguage("en");
        setLanguage("en");
        htmlTag[0].removeAttribute("dir");
        document.body.classList.remove("rtl");
        removeRTLCSS();
      }
    }
  };

  let toggleLang = async (lang: string) => {
    localStorage.setItem("lang", lang);
    i18n.changeLanguage(lang);
    authCtx.setSelectedLanguage(lang);
    setLanguage(lang);
    let htmlTag = document.getElementsByTagName("html");
    if (lang === "ar") {
      htmlTag[0].setAttribute("dir", "rtl");
      document.body.classList.add("rtl");
      addRTLCSS();
    } else {
      htmlTag[0].removeAttribute("dir");
      document.body.classList.remove("rtl");
      removeRTLCSS();
    }
  };

  const addRTLCSS = () => {
    let link = document
      .getElementById("bs5-ltr")
      ?.setAttribute(
        "href",
        "https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.rtl.min.css"
      );
  };

  const removeRTLCSS = () => {
    let link: any = document
      .getElementById("bs5-ltr")
      ?.setAttribute(
        "href",
        "https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css"
      );
  };

  return (
    <div className="btn-group mb-3 change-xl" role="group">
      <input
        type="radio"
        className="btn-check no-focus"
        name="language"
        id="language-en"
        autoComplete="off"
        checked={language === "en"}
        onChange={() => toggleLang("en")}
      />
      <label className="btn btn-sm btn-outline-primary" htmlFor="language-en">
        EN
      </label>
      <input
        type="radio"
        className="btn-check no-focus"
        name="language"
        id="language-ar"
        autoComplete="off"
        checked={language === "ar"}
        onChange={() => toggleLang("ar")}
      />
      <label className="btn btn-sm btn-outline-primary" htmlFor="language-ar">
        AR
      </label>
    </div>
  );
};

export default memo(Language);
